module.exports = __webpack_public_path__ + "img/full2-min.a7786fd5.png";